import { CustodyClientOrder } from '../../models/custody/custody-client-order.model';
import { StructuredProductsAction } from './structured-products.action';

export class StructuredProductsState {
    public error: any;
    public pending: boolean;
    public custodies: CustodyClientOrder[];
}

export const initialGenericState: StructuredProductsState = {
    error: null,
    pending: false,
    custodies: [],
};

export function StructuredProductReducer(
    state: StructuredProductsState = initialGenericState,
    action: any
) {
    switch (action.type) {
        case StructuredProductsAction.getClientCustodiesSuccess:
            return {
                ...state,
                ...{
                    pending: false,
                    custodies: action.payload,
                    error: null,
                },
            };

        default:
            return state;
    }
}
